import { useAuth } from "../auth/AuthContext";
import { CHAPTER } from "../chapter";
import { ComingSoon } from "../components/ComingSoon";

import { EmailsHub } from "./emails/EmailsHub";

/**
 * The Emails page, the only place bulk emails are sent. Australia only:
 * a build whose chapter doesn't run Emails renders nothing here, whatever
 * route or nav state reaches it. Where no email account is connected the
 * page says so instead of offering sends that would do nothing.
 */
export function Emails() {
  const { setup } = useAuth();
  if (!CHAPTER.features.includes("emails")) {
    return null;
  }
  if (!setup.email) {
    return (
      <ComingSoon
        title="Email sending isn't switched on yet"
        body="Nothing can be sent from this page until the email account is connected. Bookings are still saved."
      />
    );
  }
  return <EmailsHub />;
}
